import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, isDevMode, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { AppComponent } from './app.component';
import { ProtectedComponent } from './protected/protected.component';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from 'app/auth-guard.service';
import { AuthService } from 'app/auth.service';
import { Adal5HTTPService, Adal5Service } from 'adal-angular5';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  MatButtonModule, MatCheckboxModule, MatSidenavModule, MatNativeDateModule,
  MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS, MatDialog, MatDialogModule
} from '@angular/material';
import { MatIconModule } from '@angular/material/icon';
import { MatMomentDateModule, MomentDateAdapter, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { ExaminationModule } from './examination/examination.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StudentsModule } from 'app/students/students.module';
import { SemsoEncryptionModule } from 'app/encryption/encryption.module';
import { ExplanationService } from './examination/explanation.service';
import { XHRBackend, BrowserXhr, RequestOptions } from '@angular/http';
import { AuthInterceptor } from 'app/auth-interceptor';
import { environment } from 'environments/environment';
import { DownloadService } from './download.service';
import { StateService } from './state.service';
import { SemsoPdfViewerModule } from './semso-pdf-viewer/semso-pdf-viewer.module';
import { BreadcrumbService } from './breadcrumb/breadcrumb.service';
import { StudentsService } from './students.service';
import { SignlaterService } from './signlater.service';
import { CreboToolModule } from './crebo-tool/crebo-tool.module';
import localeNl from '@angular/common/locales/nl';
import { registerLocaleData } from '@angular/common';
import { ConfirmComponent } from './dialogs/confirm/confirm.component';
import { DialogService } from './services/dialog.service';
registerLocaleData(localeNl);

const routes: Routes = [
  {
    path: '',
    redirectTo: '/students',
    pathMatch: 'full',
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'protected',
    component: ProtectedComponent,
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'auth-callback',
    component: AuthCallbackComponent
  },
  {
    path: 'students',
    loadChildren: 'app/students/students.module#StudentsModule',
    canLoad: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: ':studentId/examination/:examinationId',
    loadChildren: 'app/examination/examination.module#ExaminationModule',
    canLoad: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'crebo-tool',
    loadChildren: 'app/crebo-tool/crebo-tool.module#CreboToolModule'
  }
];

@NgModule({
  declarations: [
    AppComponent,
    ProtectedComponent,
    AuthCallbackComponent,
    ConfirmComponent
  ],
  entryComponents: [ConfirmComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    RouterModule.forRoot(routes, { useHash: false, paramsInheritanceStrategy: 'always' }),
    HttpClientModule,
    MatButtonModule,
    ExaminationModule,
    StudentsModule,
    SemsoEncryptionModule,
    MatSidenavModule,
    PdfViewerModule,
    SemsoPdfViewerModule,
    MatNativeDateModule,
    MatIconModule,
    CreboToolModule,
    MatDialogModule
  ],
  providers: [
    AuthGuardService,
    AuthService,
    BreadcrumbService,
    StudentsService,
    Adal5Service,
    DownloadService,
    SignlaterService,
    DialogService,
    {
      provide: Adal5HTTPService, useFactory: Adal5HTTPService.factory,
      deps: [HttpClient, Adal5Service]
    }, ExplanationService, DownloadService, StateService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    { provide: MAT_DATE_LOCALE, useValue: 'nl-NL' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts